import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/museum',
    name: 'museum',
    component: () => import(/* webpackChunkName: "museum" */ '../views/Museum.vue')
  },
  {
    path: '/apparate',
    name: 'apparate',
    component: () => import(/* webpackChunkName: "apparate" */ '../views/Apparate.vue')
  },
  {
    path: '/rundgang',
    name: 'rundgang',
    component: () => import(/* webpackChunkName: "rungang" */ '../views/Rundgang.vue')
  },
  {
    path: '/video/:id',
    name: 'video',
    component: () => import(/* webpackChunkName: "video" */ '../views/Video.vue')
  },
  {
    path: '/raum/:id',
    name: 'raum',
    component: () => import(/* webpackChunkName: "raum" */ '../views/Raum.vue')
  },
  {
    path: '/raumdetail/:raum?',
    name: 'detail',
    component: () => import(/* webpackChunkName: "detail" */ '../views/Detail.vue')
  },
  {
    path: '/panorama/:id',
    name: 'panorama',
    component: () => import(/* webpackChunkName: "panorama" */ '../views/Panorama.vue')
  }
  // {
  //   path: '/messbild',
  //   name: 'messbild',
  //   component: () => import(/* webpackChunkName: "messbild" */ '../views/Messbild.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
